<!-- src/components/ezer/EzerInput.vue -->
<template>
  <div class="ezer-input">
    <textarea
      ref="inputEl"
      class="ezer-input__field"
      v-model="text"
      :disabled="disabled"
      placeholder="Ask Ezer anything..."
      rows="1"
      @keydown.enter.exact.prevent="send"
      @keydown.shift.enter.exact="newline"
      @input="autoResize"
    ></textarea>
    <button
      class="ezer-input__send"
      :disabled="disabled || !text.trim()"
      @click="send"
      aria-label="Send message"
    >
      <svg viewBox="0 0 20 20" width="18" height="18" fill="currentColor">
        <path d="M2.94 3.34a.5.5 0 0 1 .65-.24l14 6.5a.5.5 0 0 1 0 .9l-14 6.5a.5.5 0 0 1-.7-.58L4.56 11H10a.5.5 0 0 0 0-1H4.56L2.89 3.92a.5.5 0 0 1 .05-.58z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue'
export default {
  name: 'EzerInput',
  props: { disabled: Boolean },
  emits: ['send'],
  setup(props, { emit }) {
    const text = ref('')
    const inputEl = ref(null)

    function send() {
      if (props.disabled || !text.value.trim()) return
      emit('send', text.value)
      text.value = ''
      nextTick(() => autoResize())
    }
    function newline() { /* Shift+Enter = default textarea behavior */ }
    function autoResize() {
      const el = inputEl.value
      if (el) {
        el.style.height = 'auto'
        el.style.height = Math.min(el.scrollHeight, 120) + 'px'
      }
    }

    return { text, inputEl, send, newline, autoResize }
  },
}
</script>
